// extracted by mini-css-extract-plugin
module.exports = {"title":"appbar_title__2ktFg","logo":"appbar_logo__2Y21m","spacer":"appbar_spacer__MPx_X"};